import script from "./UserBar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBar.vue?vue&type=script&setup=true&lang=js"

import "./UserBar.vue?vue&type=style&index=0&id=28ff2814&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ff2814"]])

export default __exports__